/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Invite_Pending_UntilInputs */

const en_invite_pending_until = /** @type {(inputs: Invite_Pending_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open until ${i?.date}`)
};

const de_invite_pending_until = /** @type {(inputs: Invite_Pending_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offen bis ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Open until {date}" |
*
* @param {Invite_Pending_UntilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_pending_until = /** @type {((inputs: Invite_Pending_UntilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Pending_UntilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_pending_until(inputs)
	return en_invite_pending_until(inputs)
});